export enum ScrollToTopConstants {
  SET_IS_VISIBLE = 'scrollToTop/SET_IS_VISIBLE',
  SET_SCROLL_TARGET_ID = 'scrollToTop/SET_SCROLL_TARGET_ID',
}
